exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Paginator .pagination-links li:first-child {\n  margin-right: 7px; }\n\n#Paginator .pagination-links li:last-child {\n  margin-left: 7px; }\n", ""]);

// exports
